import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate, Link } from "react-router-dom";

const Sidebar = () => {
  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("isAuthenticated"); // Clear authentication state
    navigate("/"); // Redirect to login/home
  };

  return (
    <div className="col-md-2 p-0">
      <div
        className="d-flex flex-column justify-content-between"
        style={{
          height: "100vh", // full height
          position: "fixed",
          overflow: "auto",
          width: "15%",
          backgroundColor: "#004d40",
          color: "#fff",
        }}
      >
        {/* Top Section */}
        <div>
          {/* Logo */}
          <div className="text-center py-4">
            <img
              src="/Logo.png"
              alt="Riverchain"
              style={{ maxWidth: "140px" }}
            />
          </div>

          {/* Menu Items */}
          <Link
            to="/dashboard"
            className="d-flex align-items-center text-white px-3 py-2 text-decoration-none"
          >
            <i className="bi bi-speedometer2 me-2"></i>
            Dashboard
          </Link>

          <Link
            to="/dashboard"
            className="d-flex align-items-center text-white px-3 py-2 text-decoration-none"
          >
            <i className="bi bi-bar-chart-fill me-2"></i>
            Client card
          </Link>

          <Link
            to="/TransactionFiles"
            className="d-flex align-items-center text-white px-3 py-2 text-decoration-none"
          >
            <i className="bi bi-file-earmark-text me-2"></i>
            Transaction Files
          </Link>

          <Link
            to="/SavedCriteriaList"
            className="d-flex align-items-center text-white px-3 py-2 text-decoration-none"
          >
            <i className="bi bi-file-earmark-text me-2"></i>
            Saved Scoring Criteria
          </Link>

          <Link
            to="/AddCompany"
            className="d-flex align-items-center text-white px-3 py-2 text-decoration-none"
          >
            <i className="bi bi-file-earmark-text me-2"></i>
            Add company
          </Link>
        </div>

        {/* Bottom Section (Logout) */}
        <div>
          {/* Settings (above logout, but bottom area starts separately) */}
          <a
            href="#settings"
            className="d-flex align-items-center text-white px-3 py-2 text-decoration-none mt-3"
          >
            <i className="bi bi-gear me-2"></i>
            Settings
          </a>

          <Link
            to="#"
            onClick={handleLogout}
            className="d-flex align-items-center text-white px-3 py-3 text-decoration-none border-top"
          >
            <i className="bi bi-box-arrow-right me-2"></i>
            Logout
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
